// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.new-hours-row[data-v-0a50442e] {\n  border-bottom: dotted 0.5px;\n}\n.new-hours[data-v-0a50442e] {\n  display: grid !important;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
